import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=04b8143a&scoped=true&"
import script from "./AgreementModal.vue?vue&type=script&lang=js&"
export * from "./AgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=04b8143a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b8143a",
  null
  
)

export default component.exports